<div [ngClass]="{ hidden: !show, block: show }">
  <ng-content />
</div>
